/**
 * Created by Ivan on 10.08.2026
 */

const StickersCompletedWindow2 = Prefab.createWindow("stickers2_completed_window", "stickers2_completed_window_prefab_json", {
    bundles: (index) => [cleverapps.stickersBook2.collectionBundle(index)]
});
